import { SVGProps } from 'react';

const SvgWIFI = (props: SVGProps<SVGSVGElement>) => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M23.9268 6.25004C26.1371 8.50473 27.5 11.5932 27.5 15C27.5 18.4473 26.1045 21.5687 23.8477 23.83M6.25 23.9268C3.9358 21.6582 2.5 18.4968 2.5 15C2.5 11.5438 3.90277 8.4151 6.17004 6.15234"
      stroke="#2196F3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.3561 10.055C21.6823 11.3235 22.5 13.0611 22.5 14.9778C22.5 16.9172 21.6627 18.6733 20.3086 19.9455M9.75 20C8.36148 18.7236 7.5 16.945 7.5 14.9778C7.5 13.0332 8.34166 11.273 9.70202 10"
      stroke="#2196F3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="15" cy="15" r="2.5" stroke="#2196F3" strokeWidth="1.5" />
  </svg>
);

export default SvgWIFI;
